<template>
  <div>
    <!-- 案列 -->
    <div id="ListOfCases" :style="{ backgroundImage: 'url(' + backImg + ')' }">
      <div class="title_box">
        <div class="en">ENGINEERING CASE</div>
        <div class="zh">生态科技行业 领军行业新典范</div>
        <div class="line"></div>
      </div>
      <div class="list_box">
        <div
          class="item_box"
          v-for="(item, index) in ofcases"
          :key="index"
           @click="todetail(item, index)"
          :style="{
            background: 'url(' + item.img + ') no-repeat ',
          }"
        >
          <div class="text_box">
            <div class="en">{{ item.en }}</div>
            <div class="zh1">{{ item.zh1 }}</div>
            <div class="zh2">{{ item.zh2 }}</div>
            <div class="box">
              <div class="btn">查看更多</div>
              <div class="line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCase } from "../../http/api";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      ofcases: [
        {
          img: require("../../assets/components_img/temporary/listOfcases_img.png"),
          en: "TIANYUAN PIPELINE",
          zh1: "天原管道案例",
          zh2: "大品牌，硬保障，杜绝产品质量问题，实力保障安全无忧",
          case: [],
          backimg: "",
        },
        {
          img: require("../../assets/components_img/temporary/listOfcases_img.png"),
          en: "FLOOR CHANGER",
          zh1: "仟领地板系列",
          zh2: "高科技高功能地板专家，领军行业新典范",
          case: [],
          backimg: "",
        },
      ],
      backImg: "",
    };
  },
  methods: {
    todetail(item) {
      this.$router.push({
        path: "/ofCasesDetail",
        query: {
          id: item.id,
        },
      });
    },
    getData() {
      getCase().then((res) => {
        if (res.data) {
          this.ofcases.map((item, index) => {
            res.data.map((item1, index1) => {
              if (index === index1) {
                item.case = item1.case;
                item.img = item1.image;
                item.backimg = item1.background;
                item.id = item1.id;
              }
              return;
            });
            return;
          });
        }
      });
    },
  },
  mounted() {
    if (this.baclgroundInfo.length === 0) {
      setTimeout(() => {
        var obj = this.baclgroundInfo;
        this.backImg = obj[1].image;
      }, 500);
    } else {
      var obj = this.baclgroundInfo;
      this.backImg = obj[1].image;
    }
    // console.log(this.baclgroundInfo);
    this.getData();
  },
  computed: {
    baclgroundInfo() {
      return this.$store.state.baclgroundInfo;
    },
  },
};
</script>

<style scoped lang='scss'>
#ListOfCases {
  width: 100%;
  height: 100vh;
  background: #1a1a1a;
  // background-image: url("../../assets/indexImg/ListOfCases_back.png");
  background-size: cover;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title_box {
    width: 684px;
    // height: 93px;
    height: 9.3vh;
    margin: 0 auto;
    // padding-top: 160px;
    position: relative;
    margin-top: 18vh;
    .en {
      // bottom: 40px;
      bottom: 4vh;
      position: absolute;
      font-size: 67px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      // line-height: 28px;
      line-height: 2.8vh;
      z-index: 9;
      color: rgba(255, 255, 255, 0.1);
    }
    .zh {
      // font-size: 30px;
      font-size: 0.3rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // line-height: 58px;
      line-height: 5.8vh;
      color: #ffffff;
      text-align: center;
      position: absolute;
      // bottom: 10px;
      bottom: 1vh;
      width: 100%;
      z-index: 9;
    }
    .line {
      width: 80px;
      height: 4px;
      background: #0fffff;
      margin: 0 auto;
      margin-top: 8vh;
    }
  }
  .list_box {
    margin-top: 3vh;
    // width: 1426px;
    width: 74.2vw;
    min-width: 1200px;
    // height: 760px;
    height: 76vh;
    display: flex;
    position: absolute;
    top: 9vh;
    justify-content: space-between;
    .item_box {
      // width: 600px;
      min-width: 510px;
      width: 29.5vw;
      height: 100%;
      opacity: 0.6;
      transition: all 0.5s;
      position: relative;
      cursor: url("../../assets/cursor.png"), none;
      background-position: left !important;
      background-size: contain !important  ;
      .text_box {
        width: 517px;
        // height: 197px;
        height: 19.7vh;
        position: absolute;
        right: 0;
        // bottom: 52px;
        bottom: 5.2vh;
        .en {
          font-size: 38px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          // line-height: 34px;
          line-height: 3.4vh;
          color: #ffffff;
          text-align: right;
          letter-spacing: 2px;
        }
        .zh1 {
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          // line-height: 34px;
          line-height: 3.4vh;
          color: #ffffff;
          text-align: right;
          // margin: 20px 0 10px 0;
          margin: 2vh 0 1vh 0;
          letter-spacing: 5px;
        }
        .zh2 {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          text-align: right;
        }
        .box {
          // height: 48px;
          height: 4.8vh;
          // margin-top: 20px;
          margin-top: 2vh;
          display: flex;
          flex-direction: row-reverse;
          align-items: center;
          .line {
            width: 200px;
            height: 0px;
            border: 1px solid #ffffff;
            margin-right: 20px;
          }
          .btn {
            width: 120px;
            // height: 48px;
            height: 4.8vh;
            background: #ffffff;
            border: 1px solid #707070;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            // line-height: 48px;
            line-height: 4.8vh;
            color: #1a1a1a;
            text-align: center;
          }
        }
      }
    }
    .item_box:hover {
      opacity: 1;
      transition: all 0.5s;
    }
  }
}
</style>